import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  isShowModal,
  getPayload,
} from '../../../modules/emma-modal/selectors/selector';
import { objectFormat } from '../../../utils/WebUtils';
import { getLanguage } from '../../../selectors/userSelectors';

interface EmmaFullscreenModalContainerProps {
  query: any;
  isShowModal: boolean;
}

interface EmmaFullscreenModalContainerState {}

class EmmaFullscreenModalContainer extends Component<
  EmmaFullscreenModalContainerProps,
  EmmaFullscreenModalContainerState
> {
  constructor(props: EmmaFullscreenModalContainerProps) {
    super(props);
    this.state = {};
  }

  getModal(query: any) {
    const container = null;
    if (
      query &&
      query.moduleName === 'emma-modal' &&
      query.screenName === 'emma-modal-fullscreen-modal'
    ) {
      const FullscreenModalView =
        require('../FullscreenModal/FullscreenModalView').default;
      return (
        <FullscreenModalView
          {...{
            payload: query,
          }}
        />
      );
    }
    return container;
  }

  render() {
    const { isShowModal, query } = this.props;
    return isShowModal ? this.getModal(query) : null;
  }

  static mapStateToProps(state: any) {
    const language = getLanguage(state);
    const payload = getPayload(state);
    return {
      query: payload ? objectFormat(getPayload(state), language) : payload,
      isShowModal: isShowModal(state),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  EmmaFullscreenModalContainer.mapStateToProps,
  EmmaFullscreenModalContainer.mapDispatchToProps,
)(EmmaFullscreenModalContainer);
